import { gql } from '@apollo/client';

const RESTORE_STUDY_MUTATION = gql`
  mutation restoreStudy($studyId: ID!) {
    restoreStudy(studyId: $studyId) {
      isSuccess
      message
    }
  }
`;

export default RESTORE_STUDY_MUTATION;
